<template>
  <div v-if="getModalVisibility()" class="modal-wrapper">
    <div
      class="modal fade show modal-class"
      hide-header
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      footer-class="p-0"
      ref="confirmation-modal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-data"
        role="document"
      >
        <div class="modal-content">
          <div class="confirmation-modal-body d-flex justify-content-between">
            <h5>
              {{ $t('ONBOARDING.NEW_PASSWORD.CONFIRMATION_MODAL.TITLE') }}
            </h5>
            <p>
              {{ $t('ONBOARDING.NEW_PASSWORD.CONFIRMATION_MODAL.CONTENT') }}
            </p>
          </div>
          <div class="modal-footer footer-class">
            <div
              slot="modal-footer"
              class="confirmation-modal-footer px-0 justify-content-around pb-0"
            >
              <a
                href="javascript:void(0);"
                class="btn btn-flat shadow-none"
                qid="confirM-1"
                @click="modalAction('cancel')"
                >{{
                  $t('ONBOARDING.NEW_PASSWORD.CONFIRMATION_MODAL.CANCEL')
                }}</a
              >
              <a
                href="javascript:void(0);"
                class="btn btn-flat btn-submit"
                qid="confirM-2"
                @click="modalAction('change')"
                >{{
                  $t('ONBOARDING.NEW_PASSWORD.CONFIRMATION_MODAL.CHANGE')
                }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show d-block"></div>
  </div>
</template>

<script setup>
const isModalVisible = ref(false);
const emit = defineEmits(['modal-action']);
const isModalOpen = useState('is-new-pass-modal-open');
onMounted(() => {
  if (isModalOpen) {
    setModalVisibility(true);
  } else {
    setModalVisibility(false);
  }
});

const getModalVisibility = () => {
  return isModalVisible.value;
};
const setModalVisibility = (value) => {
  isModalVisible.value = value;
};

const modalAction = (action) => {
  emit('modal-action', action);
};

onBeforeUnmount(() => {
  setModalVisibility(false);
  isModalOpen.value = false;
});
</script>

<style lang="scss" scoped>
.confirmation-modal-body {
  flex-direction: column;
  border-bottom: none;
  font-size: 14px;
  color: var(--cup-general-color-4);
  padding: 15px;
  text-align: left;
}

.modal-footer {
  padding: 5px;
}

.confirmation-modal-footer {
  border: none;
  flex: 1;
  margin: 0;
  .btn-flat {
    width: 50%;
    border-radius: 0 0 0 2px;
    background-color: var(--cup-general-color-2);
    margin: 0;
    padding: 16px 0;
    font-size: 14px;
    line-height: 16px;
    color: var(--cup-general-color-4);

    &:not([disabled]):not(.disabled):active:focus,
    &:not([disabled]):not(.disabled).active:focus {
      box-shadow:
        0 0 0 0.1rem rgba(var(--cup-general-color-1-rgb), 0.5),
        inset 0 3px 5px rgba(0, 0, 0, 0.125);
    }

    &.btn-submit {
      background-color: #3287c6;
      color: var(--cup-general-color-1);

      &:not([disabled]):not(.disabled):active:focus,
      &:not([disabled]):not(.disabled).active:focus {
        box-shadow:
          0 0 0 0.1rem rgba(50, 135, 198, 0.5),
          inset 0 3px 5px rgba(0, 0, 0, 0.125);
      }
    }
  }
}

.modal-class {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-data {
  @include media-breakpoint-up(md) {
    max-width: calc(66.66vw - 30px);
  }
  @include media-breakpoint-up(lg) {
    max-width: calc(50vw - 30px);
  }
  @media (min-width: 1280px) {
    max-width: calc(640px - 30px);
  }
}

.modal-body-class {
  overflow: auto;
  max-height: 344px;
  padding: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cup-general-color-4);
  &.show {
    opacity: 0.4;
  }
}

.modal-content {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
}
</style>
